<template>
  <store-badges
    v-show="fingerprint"
    @iosBadgeClick="iosBadgeClick"
    :has-mobile-app="hasMobileApp"
    :is-ios="isIos"
    :is-android="isAndroid"
    :link-default="linkDefault"
    :link-ios="linkIos"
    :link-android="linkAndroid"
  />
</template>

<script>
import { mapState } from "vuex"
import StoreBadges from "@/shared/store-badges/store-badges"
import { writeTextToClipboard } from "@/utils/clipboard"

export default {
  name: "StoreBadgesController",
  components: { StoreBadges },
  props: {
    buttonCode: {
      type: String,
      default: "body-20200331-store_badges"
    },
    webToMobileFlag: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      fingerprint: (state) => state.user.fingerprint,
      isIos: (state) => state.user.isIos,
      isAndroid: (state) => state.user.isAndroid,
      hasMobileApp: (state) => state.user.hasMobileApp
    }),
    linkIos() {
      return this.$store.getters.downloadAppUrl({ buttonCode: this.buttonCode, platform: "ios" })
    },
    linkAndroid() {
      return this.$store.getters.downloadAppUrl({
        buttonCode: this.buttonCode,
        platform: "android",
        androidWebToMobileFlag: this.webToMobileFlag
      })
    },
    linkDefault() {
      return this.$store.getters.downloadAppUrl({ buttonCode: this.buttonCode, platform: "all" })
    }
  },
  methods: {
    iosBadgeClick() {
      if (this.webToMobileFlag) {
        writeTextToClipboard(`blinkistapp:///${this.webToMobileFlag}`)
      }
    }
  }
}
</script>
